module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "tabs-demo",
    attrs: {
      "title": "Tabs"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Tabs', [_c('TabPane', {
    attrs: {
      "label": '标签一'
    }
  }, [_vm._v("第一个标签内容")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签二'
    }
  }, [_vm._v("第二个标签内容")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签三'
    }
  }, [_vm._v("第三个标签内容")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "type-group",
    attrs: {
      "name": "type",
      "description": _vm.type_descr,
      "code": _vm.type_code
    },
    slot: "right"
  }, [_c('Tabs', {
    attrs: {
      "type": 'no_padding'
    }
  }, [_c('TabPane', {
    attrs: {
      "label": '标签一'
    }
  }, [_vm._v("不使用padding的标签1")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签二'
    }
  }, [_vm._v("不使用padding的标签2")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签三'
    }
  }, [_vm._v("不使用padding的标签3")])], 1), _vm._v(" "), _c('Tabs', {
    attrs: {
      "type": 'fix_width'
    }
  }, [_c('TabPane', {
    attrs: {
      "label": '标签一'
    }
  }, [_vm._v("平分宽度的标签1")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签二'
    }
  }, [_vm._v("平分宽度的标签2")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签三'
    }
  }, [_vm._v("平分宽度的标签3")])], 1), _vm._v(" "), _c('Tabs', {
    attrs: {
      "type": 'fix_width:20%'
    }
  }, [_c('TabPane', {
    attrs: {
      "label": '标签一'
    }
  }, [_vm._v("固定宽度为20%的标签1")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签二'
    }
  }, [_vm._v("固定宽度为20%的标签2")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签三'
    }
  }, [_vm._v("固定宽度为20%的标签3")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "icon",
      "description": "图标",
      "code": _vm.icon_code
    },
    slot: "left"
  }, [_c('Tabs', [_c('TabPane', {
    attrs: {
      "label": 'Home',
      "icon": 'home'
    }
  }, [_vm._v("第一个标签内容")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": 'Cart',
      "icon": 'shoppingcart'
    }
  }, [_vm._v("第二个标签内容")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": 'User',
      "icon": 'user'
    }
  }, [_vm._v("第三个标签内容")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "activeStyle",
      "description": "选中样式",
      "code": _vm.style_code
    },
    slot: "left"
  }, [_c('Tabs', {
    attrs: {
      "type": 'no_padding',
      "active-style": {
        color: '#f02f45',
        borderBottomColor: '#f02f45'
      }
    }
  }, [_c('TabPane', {
    attrs: {
      "label": '机酒自由行'
    }
  }, [_vm._v("机酒自由行")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '当地玩乐'
    }
  }, [_vm._v("当地玩乐")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '出行必备'
    }
  }, [_vm._v("出行必备")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01d0165c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Tabs.vue
// module id = 616
// module chunks = 0